/**
 * The persisted JSON contract for a page. Storefront RENDERS it, Builder EDITS it,
 * Theme SEEDS it. JSONB-serializable end to end. M1 uses these EXACT shapes; later
 * milestones only change WHO supplies a document, never these types.
 *
 * See docs/features/0014-storefront-page-rendering.md.
 */
// ─────────────────────────────────────────────────────────────────────────────
// Document envelope
// ─────────────────────────────────────────────────────────────────────────────
/** Current document-envelope format. Bump ONLY on a structural change to the document shape itself. */
export const PAGE_DOCUMENT_SCHEMA_VERSION = 1;
//# sourceMappingURL=types.js.map